import React from "react";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";

export default function Title(props) {
	const theme = useTheme();
	return (
		<Typography
			variant="h6"
			style={{
				fontWeight: 700,
				fontFamily: '"Inter", "Poppins", sans-serif',
				color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
				fontSize: "1.15rem",
				letterSpacing: "-0.01em",
			}}
		>
			{props.children}
		</Typography>
	);
}
